const CupIcon = (props) => {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <title>cup [#801]</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Dribbble-Light-Preview"
          transform="translate(-340.000000, -4679.000000)"
          fill="#000000"
        >
          <g id="icons" transform="translate(56.000000, 160.000000)">
            <path
              d="M298.5,4531 L298.75,4529 L301.333,4529 L300.895,4530.316 C300.758,4530.725 300.376,4531 299.946,4531 L298.5,4531 Z M291.641,4532.124 L290.25,4521 L297.75,4521 L296.359,4532.124 C296.297,4532.624 295.872,4533 295.367,4533 L292.633,4533 C292.128,4533 291.703,4532.624 291.641,4532.124 L291.641,4532.124 Z M287.105,4530.316 L286.667,4529 L289.25,4529 L289.5,4531 L288.054,4531 C287.624,4531 287.242,4530.725 287.105,4530.316 L287.105,4530.316 Z M297,4539 L297,4537 L295,4537 L295,4535 L296.234,4535 C297.243,4535 298.094,4534.249 298.219,4533.248 L298.25,4533 L300.558,4533 C301.419,4533 302.184,4532.449 302.456,4531.632 L304,4527 L299,4527 L300,4519 L288,4519 L289,4527 L284,4527 L285.544,4531.632 C285.816,4532.449 286.581,4533 287.442,4533 L289.75,4533 L289.781,4533.248 C289.906,4534.249 290.757,4535 291.766,4535 L293,4535 L293,4537 L291,4537 L291,4539 L297,4539 Z"
              id="cup-[#801]"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default CupIcon;
